export default __webpack_public_path__ + "static/media/turkgo-screenshot-02.23a9fe85.png";